<section class="back-btn">
  <i class="fa-regular fa-arrow-left fa-lg"></i>
  <a [href]="vm.mmrLink" class="button-text">Back to repairs page</a>
</section>

<section class="card">
  <h1 class="heading-4">What type of {{ vm.category | lowercase }} do you have?</h1>
  <section class="options">
    @for (type of vm.productTypeOptions; track type; let index = $index) {
      <app-radio-button
        variant="blue"
        [index]="index"
        [(ngModel)]="selectedProductType"
        [includeResetOption]="false"
        name="productType"
        [optionValue]="type"
        dataTestId="product-type-option"
      >
        {{ type }}
      </app-radio-button>
    }
  </section>

  @if (showError) {
    <p class="error-message">
      <i class="fa-light fa-circle-exclamation"></i>
      Select an option to continue
    </p>
  }

  <section class="actions">
    <app-button
      dataLabel="product-type-continue"
      [buttonOptions]="{
        variant: 'primary',
      }"
      [loading]="vm.loading"
      (onClick)="goToNextStep()"
    >
      Continue
    </app-button>
  </section>
</section>
